"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var LoggingService_1 = require("./LoggingService");
var UnityLoaderService = /** @class */ (function () {
    function UnityLoaderService() {
        /**
         * Reference to the document head.
         * @type {HTMLHeadElement}
         * @private
         */
        this.documentHead = document.getElementsByTagName("head")[0];
    }
    /**
     * Appends the Unity loader script to the window. When it's loaded a callback will
     * be triggered. NOTE: This can't be a promisse due to JavaScript compatibilty.
     * @param {string} source the path to the Unity loader file
     * @param {Function} onLoad when the script is loaded
     * @public
     */
    UnityLoaderService.prototype.append = function (source, onLoad) {
        var _this = this;
        if (typeof this.unityLoaderScript !== "undefined")
            if (source === this.unityLoaderScript.src) {
                return onLoad();
            }
            else {
                this.unityLoaderScript.remove();
            }
        window
            .fetch(source)
            .then(function (_response) {
            if (_response.status >= 400)
                return LoggingService_1.loggingService.errorUnityLoaderNotFound(_response.status);
            _response
                .text()
                .then(function (_text) {
                if (_text.trim().charAt(0) === "<")
                    return LoggingService_1.loggingService.errorUnityLoaderNotFound("error doc");
                _this.unityLoaderScript = document.createElement("script");
                _this.unityLoaderScript.type = "text/javascript";
                _this.unityLoaderScript.async = true;
                _this.unityLoaderScript.src = source;
                _this.unityLoaderScript.onload = function () {
                    if (typeof window.UnityLoader === "undefined")
                        return LoggingService_1.loggingService.errorUnityLoaderNotFound();
                    onLoad();
                };
                _this.documentHead.appendChild(_this.unityLoaderScript);
            })
                .catch(function (_reason) { return LoggingService_1.loggingService.errorUnityLoaderNotFound(_reason); });
        })
            .catch(function (_reason) { return LoggingService_1.loggingService.errorUnityLoaderNotFound(_reason); });
    };
    return UnityLoaderService;
}());
exports.default = UnityLoaderService;
